export default "__VITE_PUBLIC_ASSET__c611ba6d__"